import { MutationTree } from 'vuex';
import { RateCheckerState } from '@/views/rate-checker-configuration/rate-checker/rate-checker.types';

const mutations: MutationTree<RateCheckerState> = {
  setDataSource(state, payload: Array<string>) {
    state.dataSource = payload;
  },
  setBrandDataSource(state, payload: string) {
    state.brandDataSource = payload;
  },
  setSources(state, payload: Array<string>) {
    state.sources = payload;
  },
  setOrderListOfSources(state, payload: Array<string>) {
    state.orderListOfSources = payload;
  },
  removeDoubleSources(state) {
    state.sources = state.sources.filter((element) => state.orderListOfSources.indexOf(element) === -1);
  },
  setSource(state, payload: string) {
    const hasSource = state.orderListOfSources.find((element: string) => element === payload);
    if (!hasSource) {
      state.orderListOfSources.push(payload);
      state.sources = state.sources.filter((element: string) => element !== payload);
    } else {
      state.orderListOfSources = state.orderListOfSources.filter((element: string) => element !== payload);
      state.sources.push(payload);
    }
  },
};

export default mutations;
